import styles from './styles.module.scss';
import { useState, useEffect } from 'react';
import Card from './card';
import axios from 'axios';
import { Board } from '../../../../../../components/Board';
import { useNavigate } from 'react-router-dom';
import { verifyRoutePermissions } from '../../../../../../globalFunctions';
import { NavButton } from '../../../../../../components/NavButton';
export const LogicManagerEquipeMaintainRoute = () => {
    const [membros, setMembros] = useState<any>([]);
    const [nome, setNome] = useState('');
    const [cargo, setCargo] = useState('');
    const [imagem, setImagem] = useState<any>(null); // Inicialize como null

    const navigate = useNavigate()
    const [user,setUserAuth] = useState<any>(null)
    useEffect(() => {            

        fetchMembros();

    }, []);

    const fetchMembros = async () => {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/equipe`);
        setMembros(response.data);
    };

    const getBase64 = async(file,cb) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    useEffect(() => {
        const user = verifyRoutePermissions(
            ['auth', 'email.verified', 'not.pending.update', 'logicmanager.classes'],
            navigate
        );

        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, []);
    const sendForm  =async (formData) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/equipe`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            fetchMembros()
            setNome('');
            setCargo('');
            setImagem(null);
        } catch (error: any) {
            if (error.response && error.response.status === 422) {
                alert('Erro de validação: ' + JSON.stringify(error.response.data.errors));
            } else {
                alert('Erro ao adicionar membro: ' + error.message);
            }
        }
    }

    const adicionarMembro = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('nome', nome);
        formData.append('cargo', cargo);
        if (imagem) {
            getBase64(imagem, (result) => {
               formData.append('imagem', result);
                sendForm(formData)
           })
        }
    
       
    };

    const deletarMembro = async (id) => {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/equipe/${id}`);
        setMembros(membros.filter((membro) => membro.id !== id));
    };

    const goBackwards = () => {     
        navigate('/manager');       
};

    return (

<div className={styles.wrapper}>
<Board wrapperClass={styles.board}>

        <div className={styles.container}>
            <h1 className={styles.titulo}>Equipe</h1>
                <input
                    type="text"
                    placeholder="Cargo"
                    value={cargo}
                    onChange={(e) => setCargo(e.target.value)}
                    required
                />
                 <input
                    type="text"
                    placeholder="Nome"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    required
                />
                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setImagem(e.target.files && e.target.files[0])} // Define a imagem selecionada
                />
                <button type="submit" onClick={adicionarMembro} style={{ backgroundColor: 'green', color: 'white' }}>Adicionar Membro</button>
            <div className={styles.lista}>
                {membros.map((membro) => (
                    <Card  membro={membro} deletarMembro={deletarMembro}/>
                ))}
            </div>
        </div>
                    </Board>
                    <NavButton
                            direction='left'
                            style={{ left: '0.4vw', top: '2vw', zIndex: '20' }}
                            onClick={goBackwards}
                            /> 
                    </div>
    );
};

